import { isEmpty } from 'lodash';

import { ChronicDisease } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { SidePanelSlots, StrongText, StyledFlex } from '@dreryk/react-components';

import { AttachmentsLinks } from '~legacy.patient';

type ChronicDiseaseCategoryContentProps = {
   readonly chronicDisease: ChronicDisease;
   readonly onShowMoreAttachmentsClick: VoidFunction;
};

export const ChronicDiseaseCategoryContent = (props: ChronicDiseaseCategoryContentProps): JSX.Element => {
   return (
      <StyledFlex direction={'column'} gap={10}>
         {props.chronicDisease.diagnosis ? (
            <StrongText testId={'diagnosisName'}>
               {props.chronicDisease.diagnosis.getCode().asString()}{' '}
               {props.chronicDisease.diagnosis.getName().asString()}
            </StrongText>
         ) : null}

         {props.chronicDisease.description ? (
            <SidePanelSlots.Expandable>{props.chronicDisease.description}</SidePanelSlots.Expandable>
         ) : null}

         {isEmpty(props.chronicDisease.attachments) ? null : (
            <AttachmentsLinks
               attachments={props.chronicDisease.attachments}
               onShowMoreAttachmentsClick={props.onShowMoreAttachmentsClick}
            />
         )}
      </StyledFlex>
   );
};
